import type {
  ActualVsBudgetCompanyFixture,
  ActualVsBudgetMetricFixture,
} from '@/features/actual-vs-budget/types'

export function roundFixtureValue(value: number, digits: number) {
  const multiplier = 10 ** digits
  return Math.round((value + Number.EPSILON) * multiplier) / multiplier
}

export function sumCompleteFixtureValues(values: readonly (number | null)[]) {
  if (!values.every((value): value is number => value !== null)) return null

  return roundFixtureValue(
    values.reduce((total, value) => total + value, 0),
    1
  )
}

export function getFixtureVariance(
  value: number | null,
  comparison: number | null
) {
  if (value === null || comparison === null) return null
  return roundFixtureValue(value - comparison, 1)
}

export function getFixtureVariancePercent(
  value: number | null,
  comparison: number | null
) {
  if (value === null || comparison === null || comparison === 0) return null
  return roundFixtureValue((value - comparison) / Math.abs(comparison), 4)
}

export function getClosedFixtureMonths(
  company: ActualVsBudgetCompanyFixture,
  metric: ActualVsBudgetMetricFixture
) {
  const latestClosedIndex = metric.months.findIndex(
    ({ periodEnd }) => periodEnd === company.latestClosedPeriodEnd
  )

  if (latestClosedIndex === -1) {
    throw new Error(
      `Missing latest closed period ${company.latestClosedPeriodEnd} for ${company.id} ${metric.key}`
    )
  }

  return {
    latestClosedIndex,
    closedMonths: metric.months.slice(0, latestClosedIndex + 1),
  }
}
